import { createSlice } from "@reduxjs/toolkit"

let data = {
  products: [],
  sales: [],
  restockHistory: [],
  loading: {
    products: false,
    sales: false,
    restockHistory: false,
    checkout: false,
    productAction: false
  },
  error: null,
  searchTerm: '',
  categoryFilter: 'all',
  categoryFilterSales: 'all',
  dateFilter: 'all',
  startDate: null,
  endDate: null,
  paymentMethodFilter: 'all',
  minAmount: '',
  maxAmount: '',
  inventoryPage: 0,
  inventoryRowsPerPage: 10,
  posPage: 0,
  posRowsPerPage: 10,
  salesPage: 0,
  salesRowsPerPage: 10,
  restockPage: 0,
  restockRowsPerPage: 5,
  sortBy: 'createdAt',
  sortOrder: 'desc',
  cart: [],
  paymentMethod: 'cash',
  productDialogOpen: false,
  restockDialogOpen: false,
  saleDetailsDialogOpen: false,
  deleteConfirmOpen: false,
  selectedProduct: null,
  selectedSale: null,
  productToDelete: null,
  showSummary: true
}

const salesSlice = createSlice({
  name: "sales",
  initialState: data,
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload;
    },
    setSales: (state, action) => {
      state.sales = action.payload;
    },
    setRestockHistory: (state, action) => {
      state.restockHistory = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = { ...state.loading, ...action.payload };
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setCategoryFilter: (state, action) => {
      state.categoryFilter = action.payload;
    },
    setCategoryFilterSales: (state, action) => {
      state.categoryFilterSales = action.payload;
    },
    setDateFilter: (state, action) => {
      state.dateFilter = action.payload;
    },
    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    setPaymentMethodFilter: (state, action) => {
      state.paymentMethodFilter = action.payload;
    },
    setMinAmount: (state, action) => {
      state.minAmount = action.payload;
    },
    setMaxAmount: (state, action) => {
      state.maxAmount = action.payload;
    },
    setInventoryPage: (state, action) => {
      state.inventoryPage = action.payload;
    },
    setInventoryRowsPerPage: (state, action) => {
      state.inventoryRowsPerPage = action.payload;
    },
    setPosPage: (state, action) => {
      state.posPage = action.payload;
    },
    setPosRowsPerPage: (state, action) => {
      state.posRowsPerPage = action.payload;
    },
    setSalesPage: (state, action) => {
      state.salesPage = action.payload;
    },
    setSalesRowsPerPage: (state, action) => {
      state.salesRowsPerPage = action.payload;
    },
    setRestockPage: (state, action) => {
      state.restockPage = action.payload;
    },
    setRestockRowsPerPage: (state, action) => {
      state.restockRowsPerPage = action.payload;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    setSortOrder: (state, action) => {
      state.sortOrder = action.payload;
    },
    addToCart: (state, action) => {
      const product = action.payload;
      const existingItem = state.cart.find(item => item.productId === product._id);
      
      if (existingItem) {
        existingItem.quantity += 1;
      } else {
        state.cart.push({
          productId: product._id,
          name: product.name,
          price: product.sellingPrice,
          quantity: 1
        });
      }
    },
    updateCartItem: (state, action) => {
      const { index, quantity } = action.payload;
      if (state.cart[index]) {
        state.cart[index].quantity = quantity;
        if (quantity <= 0) {
          state.cart.splice(index, 1);
        }
      }
    },
    removeFromCart: (state, action) => {
      state.cart.splice(action.payload, 1);
    },
    clearCart: (state) => {
      state.cart = [];
    },
    setPaymentMethod: (state, action) => {
      state.paymentMethod = action.payload;
    },
    setProductDialogOpen: (state, action) => {
      state.productDialogOpen = action.payload;
    },
    setRestockDialogOpen: (state, action) => {
      state.restockDialogOpen = action.payload;
    },
    setSaleDetailsDialogOpen: (state, action) => {
      state.saleDetailsDialogOpen = action.payload;
    },
    setDeleteConfirmOpen: (state, action) => {
      state.deleteConfirmOpen = action.payload;
    },
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload;
    },
    setSelectedSale: (state, action) => {
      state.selectedSale = action.payload;
    },
    setProductToDelete: (state, action) => {
      state.productToDelete = action.payload;
    },
    setShowSummary: (state, action) => {
      state.showSummary = action.payload;
    },
    clearFilters: (state) => {
      state.dateFilter = 'all';
      state.startDate = null;
      state.endDate = null;
      state.paymentMethodFilter = 'all';
      state.categoryFilterSales = 'all';
      state.minAmount = '';
      state.maxAmount = '';
    }
  }
})

export const {
  setProducts,
  setSales,
  setRestockHistory,
  setLoading,
  setError,
  clearError,
  setSearchTerm,
  setCategoryFilter,
  setCategoryFilterSales,
  setDateFilter,
  setStartDate,
  setEndDate,
  setPaymentMethodFilter,
  setMinAmount,
  setMaxAmount,
  setInventoryPage,
  setInventoryRowsPerPage,
  setPosPage,
  setPosRowsPerPage,
  setSalesPage,
  setSalesRowsPerPage,
  setRestockPage,
  setRestockRowsPerPage,
  setSortBy,
  setSortOrder,
  addToCart,
  updateCartItem,
  removeFromCart,
  clearCart,
  setPaymentMethod,
  setProductDialogOpen,
  setRestockDialogOpen,
  setSaleDetailsDialogOpen,
  setDeleteConfirmOpen,
  setSelectedProduct,
  setSelectedSale,
  setProductToDelete,
  setShowSummary,
  clearFilters
} = salesSlice.actions;

export default salesSlice.reducer; 